/* eslint-disable complexity */
import { actionTypes } from '../../constants';
import { fromJS } from 'immutable';

const {
  GET_SWEEP_LIST_SUCCESS,
  GET_SWEEP_LIST_FAILURE,
  GET_SWEEP_ALERT_SUCCESS,
  GET_SWEEP_ALERT_FAILURE,
  UPDATE_SWEEP_ALERT_SUCCESS,
  UPDATE_SWEEP_ALERT_FAILURE,
  CLOSE_MODAL,
  DELETE_SWEEP_ALERT_SUCCESS,
  DELETE_SWEEP_ALERT_FAILURE,
} = actionTypes;

export const initialState = fromJS({
  sweepList: {},
  updateSweepAlert: {},
  getSweepAlert: {},
  sweepError: false,
  isError: false,
  category: '',
  sweepPacket: {},
});

const sweepList = (state = initialState, action) => {
  switch (action.type) {
    case GET_SWEEP_LIST_SUCCESS:
      return state.set('sweepList', action.payload).set('sweepError', false);

    case GET_SWEEP_LIST_FAILURE:
      return state.set('sweepError', action.payload).set('sweepList', {});

    case UPDATE_SWEEP_ALERT_SUCCESS:
      return state.set('updateSweepAlert', action);

    case UPDATE_SWEEP_ALERT_FAILURE:
      return state
        .set('isError', { isError: true })
        .set('category', action.meta.category)
        .set('sweepPacket', action.meta.sweepPacket);

    case GET_SWEEP_ALERT_SUCCESS:
      return state.set('getSweepAlert', action.payload);

    case GET_SWEEP_ALERT_FAILURE:
      return state
        .set('isError', { isError: true })
        .set('category', action.meta.category)
        .set('sweepPacket', action.meta.sweepPacket);

    case CLOSE_MODAL:
      return state.set('isError', { isError: false });

    case DELETE_SWEEP_ALERT_SUCCESS:
      return state.set('deleteSweep', action.payload);

    case DELETE_SWEEP_ALERT_FAILURE:
      return state.set('isError', { isError: true }).set('category', action.meta.category);

    default:
      return state;
  }
};

export default sweepList;
